<script>

export default {
  data() {
    return {
      perMonth: {},
      months: {
        1: 'januari',
        2: 'februari',
        3: 'maart',
        4: 'april',
        5: 'mei',
        6: 'juni',
        7: 'juli',
        8: 'augustus',
        9: 'september',
        10: 'oktober',
        11: 'november',
        12: 'december',
      }
    }
  },

  methods: {
    getPerMonth() {
      $.ajax({
        url: route('api.v1.appointments.werkzaamheden'),
        success: (response) => {
          this.perMonth = response.data;
        }
      })
    }
  },

  mounted() {
    this.getPerMonth();
  }
}
</script>

<template>
  <table class="table table-striped table-sm m-0">
    <thead>
      <tr>
        <th>Maand</th>
        <th>Aantal uren</th>
      </tr>
    </thead>

    <tbody>
      <tr v-for="(hours, month) in perMonth">
        <td>{{ months[month] }}</td>
        <td>{{ hours }}</td>
      </tr>
    </tbody>
  </table>
</template>